import VideoPreviewModal from './VideoPreviewModal';

export default VideoPreviewModal;
